// src/components/QuestionRenderer.jsx

import React from "react";
import "./QuestionRenderer.css";

const QuestionRenderer = ({ question, onAnswerChange, selectedAnswer }) => {

  const handleChange = (e) => {
    const value = e.target.value;
    onAnswerChange(question.id, value);
  };

  const handleDualTextboxChange = (e, field) => {
    const value = e.target.value;

    const current = Array.isArray(selectedAnswer)
      ? [...selectedAnswer]
      : ["", "", false]; // field1, field2, noSuggestionCheckbox

    if (field === "field1") current[0] = value;
    if (field === "field2") current[1] = value;

    onAnswerChange(question.id, current);
  };

  const handleNoSuggestionChange = (e) => {
    const checked = e.target.checked;

    const current = Array.isArray(selectedAnswer)
      ? [...selectedAnswer]
      : ["", "", false];

    current[2] = checked;

    // If checked → clear field2
    if (checked) current[1] = "";

    onAnswerChange(question.id, current);
  };

  const renderOptions = () => {
    if (question.ans_type === "mcq") {
      return (
        <div className="options">
          {question.mcq_options?.map((opt, idx) => (
            <label key={idx} className="option-label">
              <input
                type="radio"
                name={`question-${question.id}`}
                value={opt}
                checked={selectedAnswer === opt}
                onChange={handleChange}
              />
              {opt}
            </label>
          ))}
        </div>
      );
    }

    if (question.ans_type === "checkbox") {
      return (
        <div className="options">
          {question.mcq_options?.map((opt, idx) => (
            <label key={idx} className="option-label">
              <input
                type="checkbox"
                name={`question-${question.id}`}
                value={opt}
                checked={selectedAnswer?.includes(opt) || false}
                onChange={(e) => {
                  onAnswerChange(question.id, e.target.value, e.target.checked);
                }}
              />
              {opt}
            </label>
          ))}
        </div>
      );
    }

    if (question.ans_type === "rating") {
      const range = question.rating_scale_range || 5;
      return (
        <div className="rating-options">
          {[...Array(range)].map((_, i) => (
            <label key={i}>
              <input
                type="radio"
                name={`question-${question.id}`}
                value={i + 1}
                checked={String(selectedAnswer) === String(i + 1)}
                onChange={handleChange}
              />
              {i + 1}
            </label>
          ))}
        </div>
      );
    }

    if (question.ans_type === "textbox") {
      return (
        <textarea
          data-gramm="true"
          data-gramm_editor="true"
          data-enable-grammarly="true"
          value={selectedAnswer || ""}
          onChange={handleChange}
          placeholder="Your answer..."
          className="text-input"
        />
      );
    }

    // UPDATED dual_textbox IMPLEMENTATION
if (question.ans_type === "dual_textbox") {

  // Extract values with defaults
  const [field1, field2, disable1, disable2] = Array.isArray(selectedAnswer)
    ? selectedAnswer
    : ["", "", false, false];

  return (
    <div className="dual-textbox-container">

      {/* FIELD 1 */}
      <p className="dual-textbox-label">{question.field1_label || "Field 1"}</p>
      <textarea
        value={field1}
        disabled={disable1}
        onChange={(e) =>
          onAnswerChange(question.id, [e.target.value, field2, disable1, disable2])
        }
        placeholder={question.field1_placeholder || "Enter first response..."}
        className="text-input"
      />

      <label className="option-label" style={{ marginTop: "5px" }}>
        <input
          type="checkbox"
          checked={disable1}
          onChange={(e) =>
            onAnswerChange(question.id, [
              e.target.checked ? "" : field1,  // clear if disabling
              field2,
              e.target.checked,
              disable2
            ])
          }
        />
        No suggestion for this field
      </label>


      {/* FIELD 2 */}
      <p className="dual-textbox-label" style={{ marginTop: "15px" }}>
        {question.field2_label || "Field 2"}
      </p>
      <textarea
        value={field2}
        disabled={disable2}
        onChange={(e) =>
          onAnswerChange(question.id, [field1, e.target.value, disable1, disable2])
        }
        placeholder={question.field2_placeholder || "Enter second response..."}
        className="text-input"
      />

      <label className="option-label" style={{ marginTop: "5px" }}>
        <input
          type="checkbox"
          checked={disable2}
          onChange={(e) =>
            onAnswerChange(question.id, [
              field1,
              e.target.checked ? "" : field2,
              disable1,
              e.target.checked
            ])
          }
        />
        No suggestion for this field
      </label>

    </div>
  );
}


    return <p>Unsupported question type: {question.ans_type}</p>;
  };

  return (
    <div className="question-renderer">
      <p className="survey-question-text">{question.question}</p>
      {renderOptions()}
    </div>
  );
};

export default QuestionRenderer;
